(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["color-swatches"] && !Shopify.designMode) return;
  try {
    (function () {
    function shouldSkip() {
      var conn = navigator.connection;
      if (!conn) return false;
      if (conn.saveData) return true;
      if (conn.effectiveType && /(^|-)2g$/.test(conn.effectiveType)) return true;
      return false;
    }

    var supportsSpecRules =
      typeof HTMLScriptElement !== 'undefined' &&
      typeof HTMLScriptElement.supports === 'function' &&
      HTMLScriptElement.supports('speculationrules');

    if (supportsSpecRules && !shouldSkip()) {
      var rules = {
        prerender: [{
          source: 'document',
          where: { selector_matches: '.colour-swatch-circle-link:not(.current)' },
          eagerness: 'moderate'
        }]
      };
      var script = document.createElement('script');
      script.type = 'speculationrules';
      script.textContent = JSON.stringify(rules);
      document.head.appendChild(script);
      return;
    }

    var prefetched = new Set();

    function prefetch(url) {
      if (!url || prefetched.has(url)) return;
      prefetched.add(url);

      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = url;
      link.as = 'document';
      document.head.appendChild(link);
    }

    function schedule(fn) {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(fn, { timeout: 500 });
      } else {
        setTimeout(fn, 100);
      }
    }

    function bind(link) {
      if (link.dataset.prefetchBound) return;
      link.dataset.prefetchBound = '1';

      var handler = function () {
        if (shouldSkip()) return;
        if (link.classList.contains('current')) return;
        var href = link.getAttribute('href');
        if (!href) return;
        schedule(function () { prefetch(href); });
      };

      link.addEventListener('mouseenter', handler, { passive: true });
      link.addEventListener('focus', handler);
      link.addEventListener('touchstart', handler, { passive: true });
    }

    function init() {
      var links = document.querySelectorAll('.colour-swatch-circle-link');
      for (var i = 0; i < links.length; i++) bind(links[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["modal-find-in-store"] && !Shopify.designMode) return;
  try {
    var classes = {
    locationBtn: 'custom-location-button',
    findBtn: 'custom-find-button'
  };
  var findInStorePendingLocation = false;
  var findInStoreObserver = null;
  var findInStoreObserverPending = false;
  var findInStoreTriggerBound = false;
  var findInStoreVariantBound = false;

  function inventoryLoaderMarkup() {
    return '<div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>';
  }

  function setQuantityMessage(quantityField, message) {
    if (!quantityField || quantityField.innerHTML.trim() === message.trim()) return;
    quantityField.innerHTML = message;
  }

  function setInventoryLoadingState() {
    var loader = inventoryLoaderMarkup();
    document.querySelectorAll('.result-quantity').forEach(function(quantityField) {
      setQuantityMessage(quantityField, loader);
    });
  }

  function buildPanel(allNotes) {
    allNotes.forEach(function(container) {
      var content = container.innerHTML;
      container.classList.add('details-built');
      container.innerHTML = '<div class="details-tab">More Details</div><div class="details-content">' + content + '</div>';
      container.querySelector('.details-tab').addEventListener('click', function() {
        this.classList.toggle('details-btn-active');
        this.nextSibling.classList.toggle('details-active');
      });
    });
  }

  function customisePins(allPins) {
    var svg = '<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 26"><path d="m17.548 16.398-7.104 8.648-7.112-8.645-.145-.193-.001-.002a9.72 9.72 0 0 1-2.02-5.956c0-2.55.982-4.99 2.721-6.784a9.134 9.134 0 0 1 6.557-2.8A9.134 9.134 0 0 1 17 3.467c1.74 1.794 2.722 4.235 2.722 6.784 0 2.078-.652 4.1-1.876 5.753l-.002.002-.008.011-.03.041-.097.129-.103.137-.04.052-.012.017-.005.005a.008.008 0 0 1 0 .001Z" stroke="#010203"/></svg>';
    var svgActive = '<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 26"><path d="m17.548 16.398-7.104 8.648-7.112-8.645-.145-.193-.001-.002a9.72 9.72 0 0 1-2.02-5.956c0-2.55.982-4.99 2.721-6.784a9.134 9.134 0 0 1 6.557-2.8A9.134 9.134 0 0 1 17 3.467c1.74 1.794 2.722 4.235 2.722 6.784 0 2.078-.652 4.1-1.876 5.753l-.002.002-.008.011-.03.041-.097.129-.103.137-.04.052-.012.017-.005.005a.008.008 0 0 1 0 .001Z" fill="#010203" stroke="#010203"/></svg>';
    allPins.forEach(function(pin, idx) {
      pin.classList.add('details-built');
      pin.insertAdjacentHTML('afterend',
        '<div class="map-pin-text">' + (idx + 1) + '</div>' +
        '<div class="map-pin-svg">' + svg + '</div>' +
        '<div class="map-pin-svg-active">' + svgActive + '</div>'
      );
    });
  }

  function customisePhoneNumbers(allPhoneNumbers) {
    allPhoneNumbers.forEach(function(phoneNumber) {
      phoneNumber.classList.add('details-built');
      phoneNumber.classList.remove('stockist-feature-color');
    });
  }

  function attachInventoryMessages() {
    var messagesEl = document.getElementById('find-in-store-messages');
    if (!messagesEl) return;
    var storeMessages = JSON.parse(messagesEl.textContent);
    var allResults = document.querySelectorAll('.stockist-list-result');

    allResults.forEach(function(result) {
      if (!result.innerHTML.includes('result-wrap')) {
        result.innerHTML =
          '<div class="result-logo"></div>' +
          '<div class="result-wrap">' + result.innerHTML + '</div>' +
          '<div class="result-quantity">' + inventoryLoaderMarkup() + '</div>';
      }
    });

    if (allResults && window.ap21Stores) {
      allResults.forEach(function(result) {
        var customField = result.querySelector('.stockist-result-custom-field');
        var quantityField = result.querySelector('.result-quantity');
        if (!quantityField) return;
        if (customField) {
          var ap21Name = customField.childNodes[1] && customField.childNodes[1].textContent
            ? customField.childNodes[1].textContent
            : customField.textContent;
          var matchingStore = window.ap21Stores.find(function(store) {
            return ap21Name.trim() === store.name.trim();
          });
          if (!matchingStore) {
            setQuantityMessage(quantityField, storeMessages.itemsUnavailableMsg);
          } else if (matchingStore.stock === 0) {
            setQuantityMessage(quantityField, storeMessages.itemsUnavailableMsg);
          } else if (matchingStore.stock >= 2) {
            setQuantityMessage(quantityField, storeMessages.itemsAvailableMsg);
          } else {
            setQuantityMessage(quantityField, storeMessages.callStoreMsg);
          }
        } else {
          setQuantityMessage(quantityField, storeMessages.itemsUnavailableMsg);
        }
      });
    }
  }

  function resetResults(opts) {
    var modal = document.getElementById('find-in-store-modal-content');
    var hiddenBtn = modal ? modal.querySelector('.stockist-search-button button') : document.querySelector('.stockist-search-button button');
    if (!opts.searchInput || !hiddenBtn) {
      if ((opts.retryCount || 0) < 12) {
        window.setTimeout(function() {
          resetResults(Object.assign({}, opts, { retryCount: (opts.retryCount || 0) + 1 }));
        }, 250);
      }
      return;
    }
    opts.searchInput.value = opts.searchTerm;
    opts.searchInput.dispatchEvent(new Event('input', { bubbles: true }));
    opts.searchInput.dispatchEvent(new Event('change', { bubbles: true }));
    hiddenBtn.click();
    if (opts.type === 'pdp') return attachFindInStoreStockistObserver();
    if (opts.type === 'storeLocator') return attachStoreLocatorAppObserver();
  }

  function isGeocodeOk(status) {
    var okStatus = window.google && window.google.maps && window.google.maps.GeocoderStatus
      ? window.google.maps.GeocoderStatus.OK
      : 'OK';
    return status === okStatus || status === 'OK';
  }

  function getBestGeocodeResult(results, preferredType) {
    if (!results || !results.length) return null;
    if (preferredType) {
      var preferredResult = results.find(function(result) {
        return result.types && result.types.indexOf(preferredType) !== -1;
      });
      if (preferredResult) return preferredResult;
    }
    return results[0];
  }

  function updateSearchResults(opts) {
    findInStorePendingLocation = false;
    if (opts.emptySearch) return resetResults({ searchInput: opts.searchInput, searchTerm: 'Australia', type: opts.type });
    if (!isGeocodeOk(opts.status)) return resetResults({ searchInput: opts.searchInput, searchTerm: 'Australia', type: opts.type });
    var result = getBestGeocodeResult(opts.results, opts.preferredType);
    var formatted = result && result.formatted_address;
    if (!formatted) return resetResults({ searchInput: opts.searchInput, searchTerm: 'Australia', type: opts.type });
    return resetResults({ searchInput: opts.searchInput, searchTerm: formatted, type: opts.type });
  }

  function getReverseGeocodingData(lat, lng, searchInput) {
    if (!window.google || !window.google.maps || !window.google.maps.Geocoder) {
      return resetResults({ searchInput: searchInput, searchTerm: 'Australia', type: 'pdp' });
    }
    var geocoder = new window.google.maps.Geocoder();
    var latlng = new window.google.maps.LatLng(lat, lng);
    geocoder.geocode({ location: latlng }, function(results, status) {
      updateSearchResults({ results: results, status: status, searchInput: searchInput, type: 'pdp' });
    });
  }

  function getFindInStoreSearchInput() {
    var modal = document.getElementById('find-in-store-modal-content');
    var searchBar = modal ? modal.querySelector('.stockist-query-entry') : document.querySelector('.stockist-query-entry');
    return searchBar && searchBar.querySelector('input');
  }

  function getFindInStoreLabel(key, fallback) {
    return window.findInStoreLabels && window.findInStoreLabels[key] ? window.findInStoreLabels[key] : fallback;
  }

  function setFindInStoreSearchRadius(radius) {
    window.__stockist_search_radius = radius;
    var stockistClient = window.Stockist && window.Stockist.__widget && window.Stockist.__widget._client;
    if (stockistClient && typeof stockistClient.setVisitorSelectedRadius === 'function') {
      stockistClient.setVisitorSelectedRadius(radius);
    }
  }

  function requestCurrentLocation(searchInput) {
    if (!searchInput || !navigator.geolocation) {
      findInStorePendingLocation = false;
      return;
    }

    setFindInStoreSearchRadius(25);

    navigator.geolocation.getCurrentPosition(
      function(pos) {
        getReverseGeocodingData(pos.coords.latitude, pos.coords.longitude, searchInput);
      },
      function(err) {
        findInStorePendingLocation = false;
        console.warn('Geolocation error:', err.message);
      },
      { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 }
    );
  }

  function queueCurrentLocationSearch() {
    findInStorePendingLocation = true;
    var searchInput = getFindInStoreSearchInput();

    if (searchInput) {
      findInStorePendingLocation = false;
      requestCurrentLocation(searchInput);
    }
  }

  function createCustomCurrLocationBtn(searchBar, searchInput) {
    if (searchBar.parentNode && searchBar.parentNode.querySelector('.' + classes.locationBtn)) return;
    searchBar.insertAdjacentHTML('afterend',
      '<button type="button" class="' + classes.locationBtn + ' btn btn--full btn--dark"><span>' + getFindInStoreLabel('currentLocation', 'Use my current location') + '</span></button>');
    searchBar.nextElementSibling.addEventListener('click', function() {
      requestCurrentLocation(searchInput);
    });
  }

  function createCustomFindBtn(searchInput) {
    if (searchInput.nextElementSibling && searchInput.nextElementSibling.classList.contains(classes.findBtn)) return;
    searchInput.insertAdjacentHTML('afterend',
      '<button type="button" class="' + classes.findBtn + ' btn btn--full btn--dark">' + getFindInStoreLabel('search', 'SEARCH') + '</button>');
  }

  function runGeoCoder(opts) {
    var value = opts.value || '';
    var trimmedValue = value.trim();
    var emptySearch = !trimmedValue || trimmedValue === 'Australia';
    if (emptySearch) return updateSearchResults({ searchInput: opts.searchInput, emptySearch: true, type: opts.type });
    var isPostCode = /^\d{4}$/.test(trimmedValue);
    setFindInStoreSearchRadius(100);
    if (!window.google || !window.google.maps || !window.google.maps.Geocoder) {
      return resetResults({ searchInput: opts.searchInput, searchTerm: 'Australia', type: opts.type });
    }
    var geocoder = new window.google.maps.Geocoder();
    var geocodeRequest = {
      address: trimmedValue + ', Australia',
      componentRestrictions: { country: 'AU' },
      region: 'AU'
    };

    if (isPostCode) {
      geocodeRequest.componentRestrictions.postalCode = trimmedValue;
    }

    var handleGeocodeResponse = function(results, status) {
      updateSearchResults({
        results: results,
        status: status,
        searchInput: opts.searchInput,
        type: opts.type,
        preferredType: isPostCode ? 'postal_code' : null
      });
    };

    geocoder.geocode(geocodeRequest, function(results, status) {
      if (!isGeocodeOk(status) && isPostCode) {
        geocoder.geocode({ address: trimmedValue + ' Australia', region: 'AU' }, handleGeocodeResponse);
        return;
      }
      handleGeocodeResponse(results, status);
    });
  }

  function geocodeUserQuery(opts) {
    var root = opts.searchInput.closest('#find-in-store-modal-content') || document;
    var findButton = root.querySelector('.' + classes.findBtn);
    if (findButton && !findButton.dataset.geocodeBound) {
      findButton.dataset.geocodeBound = 'true';
      findButton.addEventListener('click', function() {
        runGeoCoder({ searchInput: opts.searchInput, value: opts.searchInput.value, type: opts.type });
      });
    }
    if (opts.searchInput.dataset.geocodeBound === 'true') return;
    opts.searchInput.dataset.geocodeBound = 'true';
    opts.searchInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); }
    });
    opts.searchInput.addEventListener('keyup', function(e) {
      if (e.key === 'Enter') runGeoCoder({ searchInput: opts.searchInput, value: e.target.value, type: opts.type });
    });
  }

  function attachStoreLocatorAppObserver() {
    var observer = new MutationObserver(function(mutations, instance) {
      var searchBar = document.querySelector('.stockist-query-entry');
      var searchInput = searchBar && searchBar.querySelector('input');
      var allNotes = document.querySelectorAll('.stockist-side-panel .stockist-result-notes:not(.details-built)');
      var allPhoneNumbers = document.querySelectorAll('.stockist-side-panel .stockist-result-phone > a:not(.details-built)');
      var allPins = document.querySelectorAll('.stockist-side-panel .stockist-icon-marker:not(.details-built)');
      if (searchInput && allNotes.length && allPhoneNumbers && allPins.length) {
        geocodeUserQuery({ searchInput: searchInput, type: 'storeLocator' });
        customisePins(allPins);
        buildPanel(allNotes);
        customisePhoneNumbers(allPhoneNumbers);
        instance.disconnect();
      }
    });
    observer.observe(document, { childList: true, subtree: true });
  }

  function processFindInStoreStockist() {
    var modalLoaded = document.querySelector('#find-in-store-modal-content');
    if (!modalLoaded) return;

    var searchForm = modalLoaded.querySelector('form.stockist-search-form');
    if (searchForm) searchForm.onsubmit = function() { return false; };

    var listResults = modalLoaded.querySelectorAll('.stockist-list-result');
    var searchBar = modalLoaded.querySelector('.stockist-query-entry');
    var searchInput = searchBar && searchBar.querySelector('input');
    var map = modalLoaded.querySelector('.stockist-map-google');
    if (map && map.dataset.findInStoreHidden !== 'true') {
      map.dataset.findInStoreHidden = 'true';
      map.setAttribute('hidden', 'hidden');
      map.style.display = 'none';
    }

    if (searchInput) {
      if (!modalLoaded.querySelector('.' + classes.locationBtn)) createCustomCurrLocationBtn(searchBar, searchInput);
      if (!modalLoaded.querySelector('.' + classes.findBtn)) createCustomFindBtn(searchInput);
      geocodeUserQuery({ searchInput: searchInput, type: 'pdp' });

      if (findInStorePendingLocation) {
        findInStorePendingLocation = false;
        requestCurrentLocation(searchInput);
      }
    }

    if (listResults.length) attachInventoryMessages();
  }

  function runFindInStoreProcessingBurst() {
    [0, 100, 300, 750, 1500, 3000, 5000].forEach(function(delay) {
      window.setTimeout(processFindInStoreStockist, delay);
    });
  }

  function attachFindInStoreStockistObserver() {
    if (findInStoreObserver) findInStoreObserver.disconnect();
    findInStoreObserver = new MutationObserver(function() {
      if (findInStoreObserverPending) return;
      findInStoreObserverPending = true;
      window.requestAnimationFrame(function() {
        findInStoreObserverPending = false;
        processFindInStoreStockist();
      });
    });
    findInStoreObserver.observe(document.querySelector('#find-in-store-modal-content') || document, { childList: true, subtree: true });
    runFindInStoreProcessingBurst();
  }

  function getSelectedVariantInventory(variantId) {
    var selectedVariantId = variantId;
    var productSelect = document.querySelector('[data-product-select]');
    if (!selectedVariantId && productSelect) selectedVariantId = productSelect.value;
    if (!selectedVariantId) return;

    var swymProduct = window.SwymProductInfo && window.SwymProductInfo.product;
    var productId = swymProduct && swymProduct.id ? swymProduct.id : window.debug_prod_id;
    var productInventoryData = productId && window.inventories && window.inventories[productId]
      ? window.inventories[productId]
      : Object.values(window.inventories || {})[0] || {};
    return productInventoryData[selectedVariantId];
  }

  function bindFindInStoreTrigger() {
    if (findInStoreTriggerBound) return;
    findInStoreTriggerBound = true;
    document.addEventListener('click', function(event) {
      if (!event.target.closest('#find-in-store')) return;
      queueCurrentLocationSearch();
      runFindInStoreProcessingBurst();
    });
  }

  function getAP21StockData(variantId) {
    var selectedInventory = getSelectedVariantInventory(variantId);
    if (!selectedInventory || !selectedInventory.variantSku) return;

    window.ap21Stores = null;
    setInventoryLoadingState();

    var variantSku = selectedInventory.variantSku;
    fetch('https://' + window.location.hostname + '/apps/dotapparel21/api-checkStock?sku=' + variantSku)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var stores = Object.values(data)[0] || [];
        window.ap21Stores = stores.map(function(s) { return { name: s.attributes.storeName, stock: s.attributes.freeStock }; });
        attachInventoryMessages();
      })
      .catch(function(err) { console.warn(err); });
  }

  function initFindInStorePdp() {
    bindFindInStoreTrigger();
    getAP21StockData();
    attachFindInStoreStockistObserver();
    if (!findInStoreVariantBound) {
      findInStoreVariantBound = true;
      document.addEventListener('variant:change', function(event) {
        var variant = event.detail && event.detail.variant;
        if (variant) getAP21StockData(variant.id);
      });
    }
  }

  function runWhenDocumentReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
      return;
    }
    callback();
  }

  /* Init: only on PDP pages (not gift cards) */
  if (window.location.pathname.includes('/products/') && !window.location.pathname.includes('/gift-card')) {
    runWhenDocumentReady(initFindInStorePdp);
    document.addEventListener('page:loaded', initFindInStorePdp);
  }

  /* Init: store locator page */
  if (window.location.pathname.includes('/store-locator')) {
    attachStoreLocatorAppObserver();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tagalys-autocomplete"] && !Shopify.designMode) return;
  try {
    (function() {
  var cfg = window.__pcInstantSearch;
  if (!cfg) return;

  var container = document.querySelector('[data-instant-search]');
  var inner = document.querySelector('[data-instant-search-inner]');
  if (!container || !inner) return;

  var activeInput = null;
  var currentQuery = '';
  var lastResponse = null;
  var debounceTimer = null;
  var fetchController = null;
  var isVisible = false;

  // --- Utilities ---

  function esc(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  function formatMoney(amount) {
    if (amount == null) return '';
    var n = typeof amount === 'number' ? amount : parseFloat(amount);
    if (isNaN(n)) return '';
    var fmt = cfg.moneyFormat || '${{amount}}';
    var decimals = n.toFixed(2);
    var noDecimals = Math.round(n).toString();
    var withComma = decimals.replace('.', ',');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, decimals)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals);
  }

  // --- Show / Hide / Position ---

  function show() {
    container.style.display = '';
    container.offsetHeight; // force reflow
    container.classList.add('tis--visible');
    isVisible = true;
    positionDropdown();
  }

  function hide() {
    container.classList.remove('tis--visible');
    container.style.display = 'none';
    isVisible = false;
  }

  function positionDropdown() {
    if (!activeInput) return;
    var searchBar = activeInput.closest('.site-header__search-container');
    if (!searchBar) return;
    var barRect = searchBar.getBoundingClientRect();
    var inputRect = activeInput.getBoundingClientRect();
    container.style.position = 'fixed';
    container.style.top = (barRect.bottom + 2) + 'px';
    container.style.left = inputRect.left + 'px';
  }

  // --- Render: focus state (recent + popular) ---

  function renderFocusState() {
    if (cfg.useTagalys) {
      if (tagalysReady && tagalysInstance && tagalysInstance.helpers) {
        tagalysInstance.helpers.getRecentAndPopularSearches(5, 10).then(function(result) {
          var recent = (result.recentSearches || []).map(function(item) { return item.query || ''; }).filter(Boolean);
          var popular = (result.popularSearches || []).map(function(item) { return item.query || ''; }).filter(Boolean);
          renderRecentAndPopular(recent, popular);
        });
      } else {
        // SDK not ready yet — retry when it loads
        window.onTagalysReady(function() {
          if (activeInput && document.activeElement === activeInput && currentQuery.length < 2) {
            renderFocusState();
          }
        });
      }
    } else {
      renderRecentAndPopular([], []);
    }
  }

  function renderRecentAndPopular(recent, popular) {
    // Deduplicate: remove popular items that appear in recent
    var recentLower = recent.map(function(s) { return s.toLowerCase(); });
    popular = (popular || []).filter(function(term) {
      return recentLower.indexOf(term.toLowerCase()) === -1;
    });

    if (!recent.length && !popular.length) {
      inner.innerHTML = '';
      hide();
      return;
    }

    var html = '';

    if (recent.length) {
      html += '<div class="tis__section">';
      html += '<div class="tis__heading">' + esc(cfg.labels.recentSearches) + '</div>';
      recent.forEach(function(term) {
        html += '<div class="tis__recent-row">';
        html += '<a href="/search?q=' + encodeURIComponent(term) + '" class="tis__item-link tis__recent-link" data-recent-term="' + esc(term) + '">' + esc(term) + '</a>';
        html += '<button class="tis__remove" data-remove-recent="' + esc(term) + '" aria-label="Remove" type="button">&times;</button>';
        html += '</div>';
      });
      html += '</div>';
    }

    if (popular.length) {
      html += '<div class="tis__section">';
      html += '<div class="tis__heading">' + esc(cfg.labels.popularSearches) + '</div>';
      popular.forEach(function(term) {
        html += '<a href="/search?q=' + encodeURIComponent(term) + '" class="tis__item-link" data-suggestion-query="' + esc(term) + '">' + esc(term) + '</a>';
      });
      html += '</div>';
    }

    inner.innerHTML = html;
    show();
    prefetchProducts();
  }

  // --- Render: search results ---
  // data shape: { suggestions[], products[], totalCount }

  function renderResults(data) {
    lastResponse = data;
    var suggestions = (data.suggestions || []).slice(0, 6);
    var collections = (data.collections || []).reduce(function(acc, c) {
      if (c.url && !acc.some(function(x) { return x.url === c.url; })) acc.push(c);
      return acc;
    }, []).slice(0, 6);
    var products = (data.products || []).slice(0, 6);
    var totalCount = data.totalCount || 0;

    if (!suggestions.length && !collections.length && !products.length) {
      inner.innerHTML = '';
      hide();
      return;
    }

    var html = '';

    // Query suggestions (2-column flex layout matching live site)
    if (suggestions.length) {
      html += '<div class="tis__terms">';
      html += '<div class="tis__terms-options">';
      suggestions.forEach(function(item) {
        html += '<div class="tis__term-option">';
        html += '<a href="' + esc(item.url) + '" class="tis__term-link" data-suggestion-query="' + esc(item.text) + '">' + esc(item.text) + '</a>';
        html += '</div>';
      });
      html += '</div>';
      html += '</div>';
    }

    // Collections
    if (collections.length) {
      html += '<div class="tis__section">';
      html += '<div class="tis__heading">Collections</div>';
      collections.forEach(function(c) {
        html += '<a href="' + esc(c.url) + '" class="tis__item-link">' + esc(c.title) + '</a>';
      });
      html += '</div>';
    }

    // Products
    if (products.length) {
      html += '<div class="tis__content">';
      html += '<h5 class="tis__products-title">' + esc(cfg.labels.products) + '</h5>';
      html += '<div class="tis__results">';
      products.forEach(function(p) {
        var imgSrc = p.image || '';
        if (imgSrc && imgSrc.indexOf('?') === -1) imgSrc += '?width=120';
        if (imgSrc && imgSrc.indexOf('//') === 0) imgSrc = 'https:' + imgSrc;
        var handle = p.handle || p.url.replace('/products/', '');
        var hasPrice = p.price != null && !isNaN(p.price);
        var hasComparePrice = hasPrice && p.comparePrice != null && !isNaN(p.comparePrice) && p.comparePrice > p.price;
        var priceText = hasPrice ? formatMoney(p.price) : '';
        if (p.priceVaries) priceText = cfg.labels.fromPrice.replace('[price]', priceText);
        html += '<a href="' + esc(p.url) + '" class="tis__product" data-product-handle="' + esc(handle) + '">';
        if (imgSrc) {
          html += '<span class="tis__product-img-wrap"><img src="' + esc(imgSrc) + '" alt="' + esc(p.title) + '" loading="lazy" /></span>';
        }
        html += '<span class="tis__product-info">';
        if (hasPrice) {
          html += '<span class="tis__product-price-block">';
          html += '<span class="tis__product-price' + (hasComparePrice ? ' tis__product-price--sale' : '') + '">' + priceText + '</span>';
          if (hasComparePrice) {
            html += '<span class="tis__product-price tis__product-price--list">' + formatMoney(p.comparePrice) + '</span>';
          }
          html += '</span>';
        }
        html += '<span class="tis__product-title">' + esc(p.title) + '</span>';
        html += '</span>';
        html += '</a>';
      });
      html += '</div>';

      // CTA
      var q = currentQuery;
      var ctaLabel;
      if (totalCount > 0) {
        ctaLabel = cfg.labels.viewResults
          .replace('[count]', totalCount)
          .replace('[query]', esc(q));
      } else {
        ctaLabel = cfg.labels.viewResultsNoCount.replace('[query]', esc(q));
      }
      html += '<div class="tis__cta">';
      html += '<a href="/search?q=' + encodeURIComponent(q) + '" class="tis__cta-link" data-cta-search>' + ctaLabel + '</a>';
      html += '</div>';
      html += '</div>';
    }

    inner.innerHTML = html;
    show();
    prefetchProducts();
  }

  // =====================================================================
  // API: Shopify Predictive Search (fallback)
  // =====================================================================

  function callShopifySearch(query) {
    if (fetchController) fetchController.abort();
    fetchController = new AbortController();

    var url = '/search/suggest.json'
      + '?q=' + encodeURIComponent(query)
      + '&resources[type]=product,query'
      + '&resources[limit]=6'
      + '&resources[limit_scope]=each'
      + '&resources[options][unavailable_products]=hide';

    fetch(url, { signal: fetchController.signal })
      .then(function(res) {
        if (!res.ok) throw new Error(res.status);
        return res.json();
      })
      .then(function(json) {
        var r = json.resources && json.resources.results;
        if (!r) { hide(); return; }
        renderResults(normalizeShopify(r));
      })
      .catch(function(err) {
        if (err.name === 'AbortError') return;
        hide();
      });
  }

  function normalizeShopify(r) {
    var suggestions = (r.queries || []).map(function(q) {
      return {
        text: q.text || '',
        styledText: q.styled_text || null,
        url: q.url || ('/search?q=' + encodeURIComponent(q.text || ''))
      };
    });

    var products = (r.products || []).map(function(p) {
      // Shopify returns prices in cents as strings
      var price = parseInt(p.price_min || p.price, 10) || 0;
      var priceMax = parseInt(p.price_max || p.price, 10) || 0;
      var compare = parseInt(p.compare_at_price_max || p.compare_at_price_min || '0', 10);
      return {
        title: p.title || '',
        url: p.url || ('/products/' + p.handle),
        image: p.image || '',
        // Convert cents to dollars for formatMoney
        price: price / 100,
        comparePrice: compare / 100,
        priceVaries: priceMax > price
      };
    });

    return { suggestions: suggestions, products: products, totalCount: 0 };
  }

  // =====================================================================
  // API: Tagalys Search Suggestions (SDK APIConnector)
  // =====================================================================

  var tagalysInstance = null;
  var tagalysReady = false;
  var pendingTagalysQuery = null;

  function initTagalys() {
    if (typeof window.onTagalysReady !== 'function') return;
    window.onTagalysReady(function() {
      var connector = Tagalys.APIConnector;
      if (!connector || !connector.SearchSuggestions) return;

      tagalysInstance = connector.SearchSuggestions.new({
        params: {
          sections: {
            popular_searches: { count: 5 },
            collections: { count: 5 },
            products: {
              include: ['total_count', 'items'],
              count: 6
            }
          }
        },
        onSuccess: function(response, helpers) {
          renderResults(normalizeTagalys(response, helpers));
        },
        onFailure: function(response) {
          console.warn('[Tagalys autocomplete] onFailure:', response);
          hide();
        }
      });

      tagalysReady = true;

      if (pendingTagalysQuery) {
        var q = pendingTagalysQuery;
        pendingTagalysQuery = null;
        tagalysInstance.helpers.updateQuery(q, 300);
      }
    });
  }

  function callTagalysSearch(query) {
    if (!tagalysReady || !tagalysInstance) {
      pendingTagalysQuery = query;
      return;
    }
    tagalysInstance.helpers.updateQuery(query);
    // Fetch text suggestions from Shopify as fallback (Tagalys may not have them enabled)
    fetchShopifyTextSuggestions(query);
  }

  var textSuggestionsCache = {};
  var pendingTextSuggestions = null;

  function fetchShopifyTextSuggestions(query) {
    if (textSuggestionsCache[query]) {
      pendingTextSuggestions = textSuggestionsCache[query];
      return;
    }
    var url = '/search/suggest.json'
      + '?q=' + encodeURIComponent(query)
      + '&resources[type]=query,collection'
      + '&resources[limit]=6'
      + '&resources[limit_scope]=each';

    fetch(url)
      .then(function(res) { return res.ok ? res.json() : null; })
      .then(function(json) {
        if (!json || !json.resources || !json.resources.results) return;
        var r = json.resources.results;
        var suggestions = (r.queries || []).map(function(q) {
          return { text: q.text || '', url: '/search?q=' + encodeURIComponent(q.text || '') };
        });
        var collections = (r.collections || []).map(function(c) {
          return { title: c.title || '', url: c.url || '' };
        });
        textSuggestionsCache[query] = { suggestions: suggestions, collections: collections };
        pendingTextSuggestions = textSuggestionsCache[query];
        // Re-render with suggestions merged if we already have product results
        if (lastResponse && currentQuery === query) {
          lastResponse.suggestions = suggestions;
          lastResponse.collections = collections;
          renderResults(lastResponse);
        }
      })
      .catch(function() {});
  }

  function normalizeTagalys(response, helpers) {
    var suggestions = [];
    var products = [];
    var collections = [];
    var totalCount = 0;

    var sections = (response && response.sections) || {};
    var keys = Object.keys(sections);

    for (var i = 0; i < keys.length; i++) {
      var section = sections[keys[i]];
      var items = section.items || [];

      if (section.type === 'products') {
        totalCount = section.total_count || 0;
        for (var pi = 0; pi < items.length; pi++) {
          var p = items[pi];
          var imgSrc = '';
          if (p.featured_image && p.featured_image.src) {
            imgSrc = p.featured_image.src;
          } else if (p.images && p.images.length > 0) {
            imgSrc = p.images[0].url || p.images[0].src || '';
          } else if (p.image) {
            imgSrc = typeof p.image === 'string' ? p.image : (p.image.src || '');
          }
          var priceRaw = p.sale_price != null ? p.sale_price
            : (p.price != null ? p.price
            : (p.prices && (p.prices.sale != null ? p.prices.sale : p.prices.current != null ? p.prices.current : p.prices.price)));
          var compareRaw = p.compare_at_price != null ? p.compare_at_price
            : (p.list_price != null ? p.list_price
            : (p.prices && (p.prices.compare_at != null ? p.prices.compare_at : p.prices.list)));
          var priceNum = priceRaw != null ? parseFloat(priceRaw) : null;
          var compareNum = compareRaw != null ? parseFloat(compareRaw) : null;
          if (priceNum != null && isNaN(priceNum)) priceNum = null;
          if (compareNum != null && isNaN(compareNum)) compareNum = null;
          // Size-level markdowns: show the lowest price in the "from" format
          var minNum = p.price_min != null ? parseFloat(p.price_min) : priceNum;
          var maxNum = p.price_max != null ? parseFloat(p.price_max) : priceNum;
          if (minNum != null && !isNaN(minNum)) priceNum = minNum;
          products.push({
            title: p.title || '',
            url: '/products/' + (p.handle || ''),
            image: imgSrc,
            price: priceNum,
            comparePrice: compareNum,
            priceVaries: minNum != null && maxNum != null && !isNaN(minNum) && !isNaN(maxNum) && maxNum > minNum
          });
        }
      } else if (section.type === 'links') {
        for (var li = 0; li < items.length; li++) {
          var title = items[li].title || '';
          var link = items[li].link || '';
          if (title && link) {
            collections.push({ title: title, url: link });
          }
        }
      } else {
        // Text / query suggestions (any non-product, non-link section)
        for (var qi = 0; qi < items.length; qi++) {
          var text = items[qi].query || items[qi].title || '';
          if (text) {
            suggestions.push({
              text: text,
              url: '/search?q=' + encodeURIComponent(text)
            });
          }
        }
      }
    }

    // Text suggestions from Tagalys helpers (if enabled for this account)
    if (helpers && typeof helpers.getTextSuggestions === 'function') {
      var textSections = helpers.getTextSuggestions();
      if (textSections && textSections.length) {
        for (var si = 0; si < textSections.length; si++) {
          var sec = textSections[si];
          var secItems = sec.items || [];
          for (var qi2 = 0; qi2 < secItems.length; qi2++) {
            var text2 = secItems[qi2].query || secItems[qi2].title || '';
            if (sec.type === 'links') {
              var link2 = secItems[qi2].link || '';
              if (text2 && link2) collections.push({ title: text2, url: link2 });
            } else if (text2) {
              suggestions.push({
                text: text2,
                url: '/search?q=' + encodeURIComponent(text2)
              });
            }
          }
        }
      }
    }

    // Fallback: use Shopify Predictive Search for text suggestions if Tagalys didn't provide any
    if (!suggestions.length && !collections.length && pendingTextSuggestions) {
      suggestions = pendingTextSuggestions.suggestions || [];
      collections = pendingTextSuggestions.collections || [];
    }

    return { suggestions: suggestions, collections: collections, products: products, totalCount: totalCount };
  }

  // =====================================================================
  // Dispatcher
  // =====================================================================

  function callSearch(query) {
    if (cfg.useTagalys) {
      callTagalysSearch(query);
    } else {
      callShopifySearch(query);
    }
  }

  // --- Recent search helpers (delegates to SDK when available) ---

  function recordRecentSearch(term) {
    if (!term || !term.trim()) return;
    if (tagalysReady && tagalysInstance && tagalysInstance.helpers) {
      tagalysInstance.helpers.recordRecentSearch('q=' + encodeURIComponent(term.trim()));
    }
  }

  function removeRecentSearch(term) {
    if (tagalysReady && tagalysInstance && tagalysInstance.helpers) {
      tagalysInstance.helpers.removeRecentSearch('q=' + encodeURIComponent(term));
    }
  }

  // --- Event handling ---

  function onFocus(e) {
    activeInput = e.target;
    var val = activeInput.value.trim();
    if (val.length >= 2) {
      if (lastResponse && currentQuery === val) {
        renderResults(lastResponse);
      } else {
        currentQuery = val;
        callSearch(val);
      }
    } else {
      renderFocusState();
    }
  }

  function onInput(e) {
    var val = e.target.value.trim();
    activeInput = e.target;
    currentQuery = val;

    if (debounceTimer) clearTimeout(debounceTimer);

    if (val.length < 2) {
      lastResponse = null;
      renderFocusState();
      return;
    }

    if (cfg.useTagalys) {
      callSearch(val);
    } else {
      debounceTimer = setTimeout(function() {
        callSearch(val);
      }, 200);
    }
  }

  function onFormSubmit(e) {
    var input = e.target.querySelector('input[name="q"]');
    if (input && input.value.trim()) {
      recordRecentSearch(input.value.trim());
    }
    hide();
  }

  function bindInput(input) {
    if (!input) return;
    input.addEventListener('focus', onFocus);
    input.addEventListener('input', onInput);

    var form = input.closest('form');
    if (form) {
      form.addEventListener('submit', onFormSubmit);
    }
  }

  // --- Event delegation on container ---

  container.addEventListener('click', function(e) {
    var removeBtn = e.target.closest('[data-remove-recent]');
    if (removeBtn) {
      e.preventDefault();
      e.stopPropagation();
      removeRecentSearch(removeBtn.getAttribute('data-remove-recent'));
      renderFocusState();
      if (activeInput) activeInput.focus();
      return;
    }

    var recentLink = e.target.closest('[data-recent-term]');
    if (recentLink) {
      recordRecentSearch(recentLink.getAttribute('data-recent-term'));
      return;
    }

    var suggestionLink = e.target.closest('[data-suggestion-query]');
    if (suggestionLink) {
      recordRecentSearch(suggestionLink.getAttribute('data-suggestion-query'));
      return;
    }

    var ctaBtn = e.target.closest('[data-cta-search]');
    if (ctaBtn) {
      recordRecentSearch(currentQuery);
      return;
    }
  });

  // --- Product hover preview ---

  // Prefetch product JSON for all visible products so hover is instant
  function prefetchProducts() {
    var links = container.querySelectorAll('.tis__product[data-product-handle]');
    for (var i = 0; i < links.length; i++) {
      var handle = links[i].getAttribute('data-product-handle');
      if (handle && !previewCache[handle]) {
        (function(h) {
          fetch('/products/' + h + '.json')
            .then(function(r) { return r.json(); })
            .then(function(data) {
              if (data.product) previewCache[h] = data.product;
            })
            .catch(function() {});
        })(handle);
      }
    }
  }

  var previewPanel = document.querySelector('[data-product-preview]');
  var previewInner = previewPanel ? previewPanel.querySelector('.tis__preview-inner') : null;
  var previewArrow = previewPanel ? previewPanel.querySelector('.tis__preview-arrow') : null;
  var previewCache = {};
  var previewTimer = null;
  var currentPreviewHandle = null;

  var activeProductEl = null;

  function positionPreview() {
    if (!previewPanel || !activeProductEl) return;
    var productRect = activeProductEl.getBoundingClientRect();
    var containerRect = container.getBoundingClientRect();
    var productMidY = productRect.top + productRect.height / 2;
    var panelTop = productRect.top - containerRect.top - 20;
    panelTop = Math.max(0, panelTop);
    previewPanel.style.top = panelTop + 'px';
    // Arrow points at the product's vertical center
    if (previewArrow) {
      var arrowTop = productMidY - containerRect.top - panelTop;
      arrowTop = Math.max(16, arrowTop);
      previewArrow.style.top = arrowTop + 'px';
    }
  }

  function showPreview(handle, productEl) {
    if (!previewPanel || !previewInner) return;
    activeProductEl = productEl || null;
    if (currentPreviewHandle === handle && previewPanel.style.display !== 'none') {
      positionPreview();
      return;
    }
    currentPreviewHandle = handle;

    if (previewCache[handle]) {
      renderPreview(previewCache[handle]);
      return;
    }

    fetch('/products/' + handle + '.json')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var product = data.product;
        if (!product) return;
        previewCache[handle] = product;
        if (currentPreviewHandle === handle) renderPreview(product);
      })
      .catch(function() {});
  }

  function renderPreview(product) {
    var imgSrc = '';
    if (product.images && product.images.length) {
      imgSrc = product.images[0].src;
      if (imgSrc) imgSrc = imgSrc.replace(/\.([a-z]+)\?/, '_400x.$1?');
    }
    var variants = product.variants || [];
    var price = variants.length ? variants[0].price : '';
    var priceMax = price;
    for (var pv = 1; pv < variants.length; pv++) {
      if (parseFloat(variants[pv].price) < parseFloat(price)) price = variants[pv].price;
      if (parseFloat(variants[pv].price) > parseFloat(priceMax)) priceMax = variants[pv].price;
    }
    var priceStr = price ? '$' + parseFloat(price).toFixed(2) : '';
    if (priceStr && parseFloat(priceMax) > parseFloat(price)) {
      priceStr = cfg.labels.fromPrice.replace('[price]', priceStr);
    }
    var desc = product.body_html || '';
    // Strip HTML tags for clean text, then truncate
    var descText = desc.replace(/<[^>]+>/g, '\n').replace(/\n{2,}/g, '\n').trim();

    var h = '';
    if (imgSrc) {
      h += '<div class="tis__preview-img"><img src="' + esc(imgSrc) + '" alt="' + esc(product.title) + '" /></div>';
    }
    h += '<div class="tis__preview-details">';
    h += '<h4 class="tis__preview-title">' + esc(product.title) + '</h4>';
    if (priceStr) h += '<p class="tis__preview-price">' + priceStr + '</p>';
    if (descText) {
      // Show first ~300 chars
      var truncated = descText.length > 300 ? descText.substring(0, 300) + '...' : descText;
      h += '<div class="tis__preview-desc">' + esc(truncated).replace(/\n/g, '<br>') + '</div>';
    }
    h += '<a href="/products/' + esc(product.handle) + '" class="tis__preview-link">See details</a>';
    h += '</div>';

    previewInner.innerHTML = h;
    previewPanel.style.display = '';
    positionPreview();
  }

  function hidePreview() {
    if (previewPanel) previewPanel.style.display = 'none';
    currentPreviewHandle = null;
  }

  container.addEventListener('mouseenter', function(e) {
    var productEl = e.target.closest('.tis__product');
    if (!productEl) return;
    var handle = productEl.getAttribute('data-product-handle');
    if (!handle) return;
    clearTimeout(previewTimer);
    previewTimer = setTimeout(function() { showPreview(handle, productEl); }, 150);
  }, true);

  container.addEventListener('mouseleave', function(e) {
    var productEl = e.target.closest('.tis__product');
    if (!productEl) return;
    var related = e.relatedTarget;
    // Don't hide if moving to the preview panel or another product
    if (related && (related.closest('.tis__preview') || related.closest('.tis__product'))) return;
    clearTimeout(previewTimer);
    previewTimer = setTimeout(hidePreview, 200);
  }, true);

  // Keep preview visible when hovering over it
  if (previewPanel) {
    previewPanel.addEventListener('mouseenter', function() {
      clearTimeout(previewTimer);
    });
    previewPanel.addEventListener('mouseleave', function(e) {
      var related = e.relatedTarget;
      if (related && related.closest('.tis__product')) return;
      previewTimer = setTimeout(hidePreview, 200);
    });
  }

  // Hide preview when dropdown hides
  var origHide = hide;
  hide = function() {
    origHide();
    hidePreview();
  };

  // --- Global listeners ---

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && isVisible) {
      hide();
      if (activeInput) activeInput.blur();
    }
  });

  document.addEventListener('click', function(e) {
    if (!isVisible) return;
    if (container.contains(e.target)) return;
    var inputs = document.querySelectorAll('.tagalys-search-input');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i] === e.target || inputs[i].contains(e.target)) return;
    }
    hide();
  });

  window.addEventListener('scroll', function() {
    if (isVisible) positionDropdown();
  }, { passive: true });

  window.addEventListener('resize', function() {
    if (isVisible) positionDropdown();
  }, { passive: true });

  // --- Init ---

  function init() {
    // Move dropdown to body so it escapes the header's stacking context
    if (container.parentNode !== document.body) {
      document.body.appendChild(container);
    }

    var inputs = document.querySelectorAll('.tagalys-search-input');
    for (var i = 0; i < inputs.length; i++) {
      bindInput(inputs[i]);
    }
    if (cfg.useTagalys) initTagalys();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
